export const iconFontAwesomeTravelHotelCartShopping = (
	<i className="fa-solid fa-cart-shopping"></i>
);
